import React from 'react';
import Problems from './problems';
import OrganizationSupportTicketsIndex from './organization';
import useOrganization from '../../hooks/use-organization';

function SupportTicketsIndex() {
  const organizationInfo = useOrganization();

  return Boolean(organizationInfo?.id) ? (
    <OrganizationSupportTicketsIndex />
  ) : (
    <Problems />
  );
}

export default SupportTicketsIndex;
